// extracted by mini-css-extract-plugin
export var active = "_2g-j";
export var cell = "_2g-3";
export var cellLoading = "_2g-6";
export var center = "_2g-10";
export var clickable = "_2g-c";
export var compact = "_2g-4";
export var container = "_2g-8";
export var data = "_2g-a";
export var dataRow = "_2g-b";
export var dateRangeContainer = "_2g-2";
export var downloadIcon = "_2g-v";
export var empty = "_2g-e";
export var filter = "_2g-g";
export var filterContainer = "_2g-16";
export var filterCount = "_2g-i";
export var filterLabel = "_2g-h";
export var filters = "_2g-f";
export var header = "_2g-l";
export var headerButton = "_2g-m";
export var headerContent = "_2g-n";
export var headerLabel = "_2g-p";
export var headerRow = "_2g-u";
export var headerSort = "_2g-o";
export var headerSortAsc = "_2g-r";
export var headerSortContainer = "_2g-q";
export var headerSortDesc = "_2g-s";
export var headerSpacer = "_2g-t";
export var headers = "_2g-w";
export var infoIcon = "_2g-1b";
export var left = "_2g-z";
export var loader = "_2g-y";
export var loaderContainer = "_2g-x";
export var main = "_2g-9";
export var movingGradient = "_2g-7";
export var options = "_2g-0";
export var pageChangeButton = "_2g-1a";
export var pageControl = "_2g-17";
export var pageControlSticky = "_2g-18";
export var pageNumbers = "_2g-19";
export var right = "_2g-11";
export var seamless = "_2g-1";
export var spacer = "_2g-12";
export var table = "_2g-14";
export var tableContainer = "_2g-13";
export var tableFitToParent = "_2g-15";
export var textHeader = "_2g-k";
export var title = "_2g-d";
export var wide = "_2g-5";